let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("cM9em"), load("fr9NE"), load("1p0DY")]).then(() => parcelRequire('cHsZj'));